import axios from 'axios';
import { tokenUtils } from '../utils/tokenUtils';

const API_URL = process.env.REACT_APP_API_URL + '/Questionnaire';
const USER_QUESTIONNAIRE_RESULT_URL = process.env.REACT_APP_API_URL + '/UserQuestionnaireResult';

function getAuthHeaders() {
  const token = tokenUtils.get();
  if (!token) throw new Error('No se encontró token de autenticación');
  return {
    Authorization: `Bearer ${token}`,
  };
}

const handleAuthError = (error) => {
  if (error.response?.status === 401) {
    tokenUtils.clearAuth();
    window.location.href = '/';
  }
};

const getQuestionnaires = async () => {
  try {
    const response = await axios.get(API_URL, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al obtener cuestionarios:', error);
    throw error;
  }
};

const getQuestionnaireById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al obtener cuestionario por ID:', error);
    throw error;
  }
}

const createQuestionnaireHead = async (data) => {
  try {
    const response = await axios.post(API_URL, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al crear cuestionario:', error);
    throw error;
  }
};

const createQuestionarieQuestion = async (questionnaireId, questionData) => {
  try {
    const response = await axios.post(`${API_URL}/${questionnaireId}/questions`, questionData, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al agregar pregunta al cuestionario:', error);
    throw error;
  }
}; 

const deleteQuestionnaire = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al eliminar cuestionario:', error);
    throw error;
  }
}

const updateQuestion = async (questionId, questionData) => {
  try {
    const response = await axios.put(`${API_URL}/questions/${questionId}`, questionData, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al actualizar pregunta:', error);
    throw error;
  }
}

const submitQuestionnaireAnswers = async (questionnaireId, userId, courseId, answers) => {
  try {
    const payload = {
      questionnaireId,
      userId,
      courseId,
      answers
    };
    
    const response = await axios.post(`${API_URL}/submit-answers`, payload, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al enviar respuestas del cuestionario:', error);
    throw error;
  }
}

// NEW LEADERBOARD METHODS

const getQuestionnaireLeaderboard = async (questionnaireId) => {
  try {
    const response = await axios.get(`${USER_QUESTIONNAIRE_RESULT_URL}/questionnaire/${questionnaireId}/leaderboard`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al obtener leaderboard del cuestionario:', error);
    throw error;
  }
};

const getOverallAccuracyLeaderboard = async () => {
  try {
    const response = await axios.get(`${USER_QUESTIONNAIRE_RESULT_URL}/accuracy-leaderboard`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al obtener leaderboard de precisión general:', error);
    throw error;
  }
};

const getUserLeaderboardPosition = async (userId, questionnaireId) => {
  try {
    const response = await axios.get(`${USER_QUESTIONNAIRE_RESULT_URL}/user/${userId}/questionnaire/${questionnaireId}/position`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al obtener posición del usuario en leaderboard:', error);
    throw error;
  }
};

const getTopPerformers = async (limit = 10) => {
  try {
    const response = await axios.get(`${USER_QUESTIONNAIRE_RESULT_URL}/top-performers?limit=${limit}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al obtener top performers:', error);
    throw error;
  }
};

const getUserPerformanceSummary = async (userId) => {
  try {
    const response = await axios.get(`${USER_QUESTIONNAIRE_RESULT_URL}/user/${userId}/performance-summary`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al obtener resumen de rendimiento del usuario:', error);
    throw error;
  }
};

const getQuestionnairePerformance = async (userId, questionnaireId) => {
  try {
    const response = await axios.get(`${USER_QUESTIONNAIRE_RESULT_URL}/user/${userId}/questionnaire/${questionnaireId}/performance`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al obtener rendimiento del cuestionario:', error);
    throw error;
  }
};

const questionnairesService = {
  getQuestionnaires,
  getQuestionnaireById,
  createQuestionnaireHead,
  createQuestionarieQuestion,
  deleteQuestionnaire,
  updateQuestion,
  submitQuestionnaireAnswers,
  // NEW LEADERBOARD METHODS
  getQuestionnaireLeaderboard,
  getOverallAccuracyLeaderboard,
  getUserLeaderboardPosition,
  getTopPerformers,
  getUserPerformanceSummary,
  getQuestionnairePerformance,
};

export default questionnairesService;
